import { useSettings } from '@/api/hooks/useAdminSettings';

/**
 * Reads {@code operationalPolicies.supportedLocales} from the
 * tenant-scope settings endpoint. PR V.c added the JSONB key with a
 * default of {@code ['en-CA']} for every tenant via V90; bilingual
 * operators opt into {@code ['en-CA', 'fr-CA']} via the SettingsPage
 * locales toggle.
 *
 * <p>Returns the resolved list (never empty -- always contains at
 * least en-CA) and a {@code showFrTab} boolean for the common
 * "should the FR tab render" check in tabbed-by-locale admin forms.
 */
export function useSupportedLocales(): {
  locales: string[];
  showFrTab: boolean;
  isLoading: boolean;
} {
  const { data, isLoading } = useSettings();
  const raw = (data?.operationalPolicies as Record<string, unknown> | undefined)?.supportedLocales;
  const locales = Array.isArray(raw) && raw.length > 0
    ? (raw as string[])
    : ['en-CA'];
  return {
    locales,
    showFrTab: locales.includes('fr-CA'),
    isLoading,
  };
}
